import { set } from 'vue'

// Initial state factory function
const getDefaultState = () => {
  return {
    selectedRequest: null
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    activeRequest: (state) => state.selectedRequest,
    activeRequestId: (state) => state.selectedRequest?.helpDeskId || null,
    isRequestActive: (state) => !!state.selectedRequest
  },
  mutations: {
    SET_ACTIVE_REQUEST(state, request) {
      set(state, 'selectedRequest', request)
    },
    CLEAR_ACTIVE_REQUEST(state) {
      set(state, 'selectedRequest', null)
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    setActiveRequest({ commit }, request) {
      commit('SET_ACTIVE_REQUEST', request)
    },
    clearActiveRequest({ commit }) {
      commit('CLEAR_ACTIVE_REQUEST')
    }
  }
}
